// https://github.com/processing/p5.js/wiki/Global-and-instance-mode
import p5 from "p5";

/**
 * @param {p5} s
 */

let _rotation_speed = 2.0;
let _with_animation = true;

let _dt;
let _r_outerring;
let _r_pupil;
let _lw;
let _xc;
let _yc;
let _data;
let _size;

const sketch = function(s) {
    s.setup = function() {
        s.createCanvas(s.windowWidth, s.windowHeight);

        _xc = s.width / 2;
        _yc = s.height / 2;
        _size = Math.min(s.width, s.height);
        _size = 0.8*_size;
        _r_outerring = _size;
        _r_pupil = _size / 4;
        _lw = _size / 16;
        _dt = s.deltaTime;

        _data = [
            { num_segments: 18, radius: _r_outerring - 9 * _lw, speed_multiplier: 1 },
            { num_segments: 18, radius: _r_outerring - 7 * _lw, speed_multiplier: -1 },
            { num_segments: 18, radius: _r_outerring - 5 * _lw, speed_multiplier: 1 },
            { num_segments: 3, radius: _r_outerring - 2 * _lw, speed_multiplier: 1 },
            { num_segments: 48, radius: _r_outerring - 1 * _lw, speed_multiplier: -1 },
            { num_segments: 12, radius: _r_outerring - 0 * _lw, speed_multiplier: 1 },
        ];
        for (let i = 0; i < _data.length; i++) {
            _data[i].speed_multiplier = _data[i].speed_multiplier  / _data[i].radius;
        }
    };

    s.draw = function() {
        s.background(255);

        if (_with_animation) _dt += _rotation_speed * s.deltaTime * 0.01;
        else _dt = 0;

        s.translate(_xc, _yc);

        s.noFill();
        s.strokeWeight(_lw * 1.05);
        s.strokeCap(s.SQUARE);
        s.stroke(0, 0, 0);

        // Pupil
        s.circle(0, 0, _r_pupil);

        // Iris rays and outer rings
        for (let i = 0; i < _data.length; i++) {
            draw_circle_segments(_data[i], _dt);
        }
    };

    const draw_circle_segments = function(prop, dt) {
        s.push();
        s.rotate(dt * prop.speed_multiplier);
        let step = (2 * s.PI) / prop.num_segments;
        for (let j = 0; j < 2 * s.PI; j += step) {
            let alpha1 = j - step / 4;
            let alpha2 = j + step / 4;
            s.arc(0, 0, prop.radius, prop.radius, alpha1, alpha2);
        }
        s.pop();
    };
};

const sketchInstance = new p5(sketch, document.getElementById("sketch"));
